import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { EmailCodeForm } from '../email-code-form'
import { EmailEntityType } from '../email-code-form/types'
import { FC } from 'react'

interface Props {
  batchId: string | undefined
  onClose: () => void
  onSubmit?: ((toEmails: string) => Promise<void>) | null
  entityType?: EmailEntityType
  flowcodeImageUrl?: string
}

export const EmailCodeModalContent: FC<Props> = ({
  batchId,
  onClose,
  onSubmit = null,
  entityType,
  flowcodeImageUrl
}: Props): JSX.Element => {
  return (
    <Box justifyContent="center" width="100%" height="100%" display="block">
      <EmailCodeForm
        batchId={batchId}
        onClose={onClose}
        submitFunction={onSubmit}
        entityType={entityType}
        flowcodeImageUrl={flowcodeImageUrl}
      />
    </Box>
  )
}
